// 3.3 — the Home-tab forms list: the menu rows a visitor can come back to
// (delta spec: "Menu actions from the Home tab SHALL navigate to chat"). Only
// active, queued, submitted, and idle-with-saved-values forms are listed —
// "Not started" forms stay in the chat menu — and the list renders whenever at
// least one such row exists, for any tenant shape (a single-form tenant's
// in-progress or submitted form included), and nothing otherwise, so a first
// visit leaves the Home tab untouched. Gate and rows share `isResumableForm`.
// Also gated on the feature itself so non-forms tenants emit nothing. The Home
// tab sits outside the chat body's themed root, so the theme variables are
// re-applied here.

import { useNavigate } from 'react-router-dom';
import styles from './ConversationalForms.module.css';
import FormsMenuRows from './FormsMenu';
import { useConversationalForms } from './FormsContext';
import { isResumableForm } from './formsSelectors';
import { formsThemeVars } from './theming';

const FormsHomeList = () => {
    const navigate = useNavigate();
    const { active, registry, state, theme } = useConversationalForms();

    if (!active || !registry) return null;
    if (!registry.forms.some((f) => isResumableForm(f, state))) return null;

    return (
        <div className={styles.homeForms} style={formsThemeVars(theme)} data-testid="cf-home-forms">
            <div className={styles.homeFormsHead}>Your Forms</div>
            <FormsMenuRows resumableOnly onAction={() => navigate('/Chat')} />
        </div>
    );
};

export default FormsHomeList;
